import { DefaultTheme } from 'styled-components';

export const isShadowTheme = (theme: DefaultTheme | any) => theme?.name === 'shadowGrid';

const fallback = 'rgba(26, 35, 46, 0.8)';

export const cardBackground = (theme: DefaultTheme | any) => {
  if (isShadowTheme(theme)) {
    return theme.profile?.cards?.background ?? 'rgba(5, 6, 8, 0.78)';
  }
  return theme.colors?.surface ?? fallback;
};

export const cardBorder = (theme: DefaultTheme | any) => {
  if (isShadowTheme(theme)) {
    return theme.profile?.cards?.border ?? 'rgba(0, 255, 170, 0.25)';
  }
  return theme.colors?.borderLight ?? 'rgba(0, 212, 255, 0.3)';
};

export const cardShadow = (theme: DefaultTheme | any) => {
  if (isShadowTheme(theme)) {
    return theme.profile?.cards?.shadow ?? '0 5px 12px rgba(0, 0, 0, 0.35)';
  }
  return theme.shadows?.card ?? '0 5px 20px rgba(0, 0, 0, 0.25)';
};

export const subtleBorder = (theme: DefaultTheme | any) => {
  if (isShadowTheme(theme)) {
    return theme.colors?.borderMuted ?? 'rgba(0, 255, 170, 0.12)';
  }
  return theme.colors?.borderMuted ?? 'rgba(255, 255, 255, 0.1)';
};

export const headerBackground = (theme: DefaultTheme | any) => {
  if (isShadowTheme(theme)) {
    return theme.styles?.headerBackground ?? cardBackground(theme);
  }
  return theme.styles?.headerBackground ?? 'rgba(0, 0, 0, 0.6)';
};

export const headerBorder = (theme: DefaultTheme | any) => {
  if (isShadowTheme(theme)) {
    return theme.styles?.headerBorder ?? cardBorder(theme);
  }
  return theme.styles?.headerBorder ?? theme.colors?.border ?? 'rgba(0, 212, 255, 0.3)';
};
